import { type CanMatchFn } from '@angular/router';

import { environment } from '../../../environments/environment';

/**
 * Lets a route match only when `environment.devTools` is on, which is development only. In a
 * production build the flag is false, the route does not match, and the URL falls through to
 * the 404 page. The component gallery uses it. It needs no session, because it shows no data.
 */
export const devToolsGuard: CanMatchFn = () => environment.devTools;
